import { getEntityPageUrl } from '@/features/statisticsPage/utils';

export const ROUTE_PATH = getEntityPageUrl('campaigns');

export const FEATURE_NAME = 'locationsStatisticsPage';
